export default () => ({
  couponGames: [], // 筛选的游戏名称列表
  couponHistoryGames: [], // 筛选的游戏名称列表[历史]
  allCouponList: [], // 全部优惠券列表
  historyCouponList: [], // 全部优惠券列表[历史]
})
